<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="name,alias"
      :show-export="false"
      :show-custom-column="false"
      ref="table"
    >
      <template v-slot:toolbar>
        <el-button size="small" @click="edit()" type="primary">添加</el-button>
        <el-button size="small" @click="dialogVisible = true" class="marginLeft16">导入</el-button>
        <el-button size="small" @click="handleExport" class="marginLeft16">导出</el-button>
        <fe-delete-button :url="deleteUrl" :htTable="$refs.table" class="marginLeft16">删除</fe-delete-button>
      </template>
      <eco-table-column type="index" width="50" align="center" label="序号" />
      <eco-table-column prop="name" label="名称">
        <template slot-scope="scope">
          <el-link type="primary" @click="edit(scope.row.id)" title="查看详情">{{ scope.row.name }}</el-link>
        </template>
      </eco-table-column>
      <eco-table-column prop="alias" label="别名" :sortable="true" />
      <eco-table-column prop="dsName" label="数据源" :sortable="true" />
      <eco-table-column prop="sql" label="SQL语句" />
      <eco-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link @click="jumpToViewList(scope.row.alias)" type="primary" :underline="false">视图列表</el-link>
        </template>
      </eco-table-column>
    </eco-table>
    <custom-view-edit :id="selectedId" ref="customChartEdit" @after-save="afterSave" />
    <el-dialog title="上传文件" :visible="dialogVisible" :before-close="beforeClose" width="40%" append-to-body>
      <el-upload :action="uploadUrl" :http-request="handleImport" accept=".zip" :file-list="fileList" :limit="1">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import form from '@/api/form.js'
import req from '@/request.js'
const customViewEdit = () => import('@/components/form/customView/CustomViewEdit.vue')
export default {
  components: {
    customViewEdit
  },
  data() {
    return {
      data: [],
      pageResult: {
        page: 0,
        pageSize: 50,
        total: 0
      },
      selectedId: '',
      deleteUrl: window.context.form + '/form/query/querySqldef/remove',
      dialogVisible: false,
      file: {},
      uploadUrl: window.context.form + '/form/query/querySqldef/import',
      fileList: []
    }
  },
  methods: {
    loadData(param, cb) {
      form
        .getCustomViewList(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => {
          cb()
        })
    },
    edit(id) {
      this.$refs.customChartEdit.handleOpen()
      if (id) {
        this.selectedId = id
      } else {
        this.selectedId = ''
      }
    },
    jumpToViewList(alias) {
      this.$router.push({
        path: '/reportManager/viewList',
        query: { alias: alias }
      })
    },
    afterSave() {
      this.$refs.table.load()
    },
    handleExport() {
      let formIds = this.getSelectKeys('id')
      if (!formIds) {
        this.$message({ message: '请选择至少一项记录', type: 'warning' })
        return
      }
      let url = `${window.context.form}/form/query/querySqldef/export?ids=${formIds}`
      req.download(url)
    },
    handleImport(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      form.importCustomSql(formData).then((data) => {
        if (data.state) {
          this.$message({ type: 'success', message: data.message })
          param.onSuccess()
          this.loadData()
          this.dialogVisible = false
          this.fileList = []
        } else {
          param.onError()
        }
      })
    },
    getSelectKeys(key) {
      if (!this.$refs.table.$refs.ecoTable.selection) {
        this.$message('请选择的数据!')
        return
      }
      let ids = []
      for (let i = 0; i < this.$refs.table.$refs.ecoTable.selection.length; i++) {
        ids.push(this.$refs.table.$refs.ecoTable.selection[i][key])
      }
      return ids.join(',')
    },
    beforeClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped></style>
